module.exports = __webpack_public_path__ + "img/milk-1.277415b0.jpg";